import styled from '@emotion/styled';
import Headline3 from './Typography/Heading/Headline3';

export default styled(Headline3)`
  && {
    text-align: center;
    margin: 32px 16px 16px;
  }
`;
